import { render, staticRenderFns } from "./AmcPlans.vue?vue&type=template&id=3931f941&scoped=true"
import script from "./AmcPlans.vue?vue&type=script&lang=js"
export * from "./AmcPlans.vue?vue&type=script&lang=js"
import style0 from "./AmcPlans.vue?vue&type=style&index=0&id=3931f941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3931f941",
  null
  
)

export default component.exports